import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/ophirstudio_next/components/landing/BrandCarousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/ophirstudio_next/components/landing/HeroContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/ophirstudio_next/components/projects/List/components/Card.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/ophirstudio_next/components/projects/List/components/SeeMore.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/ophirstudio_next/components/services/ServicesSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/ophirstudio_next/components/ui/slider.tsx");
;
import(/* webpackMode: "eager" */ "/root/ophirstudio_next/node_modules/next/dist/client/link.js");
